<template>
  <div class="vx-col w-full mb-base m-auto">
    <div class="vx-row mb-5" v-if="$store.state.uInfo.role !='SA'">
      <div class="vx-col form-group left-board">
        <vx-card title v-bind:class="'header-border example'">
          <div>
            <div class="md:w-auto md:mt-0 sm:w-full w-full sm:mt-3 mt-3">
              <div class="inline-block mr-2 w-100 mb-2 mr-8 dashboard_title">In Out Board</div>
              <div class="inline-block mr-2 w-100 mb-2">
                <vs-input
                  name="search"
                  placeholder="Search"
                  class="w-full no-icon-border"
                  v-model="search"
                  autocomplete="off"
                  @keyup="getusers()"
                />
              </div>
              <div class="inline-block mr-2 w-100 mb-2">
                <vs-select
                  autocomplete
                  class="w-full"
                  v-validate="'required'"
                  name="sort"
                  placeholder="All Offices"
                  v-model="office"
                  @change="onChangeOffice()"
                >
                  <vs-select-item :value="null" text="All Offices" />
                  <vs-select-item
                    :key="index"
                    :value="sort.id"
                    :text="sort.office_name"
                    v-for="(sort,index) in allOffices"
                  />
                </vs-select>
              </div>
              <div class="inline-block mr-2 w-100 mb-2">
                <vs-select
                  autocomplete
                  class="w-full"
                  v-validate="'required'"
                  name="sort"
                  placeholder="All Deparments"
                  v-model="department"
                  @change="getusers()"
                >
                  <vs-select-item :value="null" text="All Deparments" />
                  <vs-select-item
                    :key="index"
                    :value="sort.id"
                    :text="sort.department_name"
                    v-for="(sort,index) in allDepartment"
                  />
                </vs-select>
              </div>
              <div class="inline-block mr-2 position-relative">
                <vs-button
                  radius
                  class="home-refresh"
                  type="gradient"
                  title="Refresh"
                  icon-pack="feather"
                  icon="icon-refresh-ccw"
                  @click="refreshTable()"
                ></vs-button>
              </div>
              <div class="inline-block mr-2 float-right ipad-none">
                <vs-button
                  radius
                  class="min-max-toggle"
                  type="gradient"
                  icon-pack="feather"
                  :icon="fullscreen ? 'icon-minimize' : 'icon-maximize'"
                  @click="toggle"
                ></vs-button>
              </div>
            </div>

            <!-- <div class="float-left add-drivers mr-2">
              <vs-button
                class="m-auto"
                color="primary"
                title="Export Data"
                @click.stop="exportCSV()"
              >Export</vs-button>
            </div>-->
            <!-- <div class="float-left inline-block ml-5">
              <vs-button
                radius
                color="primary"
                type="gradient"
                title="Refresh"
                icon-pack="feather"
                icon="icon-refresh-ccw"
                @click="refreshTable()"
              ></vs-button>
            </div>-->
          </div>
          <div class="clearfix"></div>
          <div class="mt-5 mb-5">
            <vs-table :data="organisationUsers">
              <template slot="thead">
                <vs-th sort-key="firstname"  style="min-width: 150px;">Name</vs-th>
                <!-- <vs-th>First Name</vs-th>
                <vs-th>Last Name</vs-th>-->
                <vs-th width="500px">Comment</vs-th>
                <vs-th sort-key="due_back">Due Back</vs-th>
                <vs-th>Phone</vs-th>
                <vs-th width="90px" class="pr-0">Updated</vs-th>
                <vs-th width="40px" class="pl-1 pr-1"></vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <div class="relative inline-flex float-left" v-if="tr.inoutreference">
                      <vs-avatar
                        class="m-0"
                        :src="tr.profile_image"
                        size="40px"
                        v-if="tr.profile_image"
                      />
                      <vs-avatar
                        color="primary"
                        class="m-0 name-avatar"
                        :text="usernameList(tr.firstname,tr.lastname)"
                        size="40px"
                        v-else
                      />
                      <div
                        class="user-inout absolute pin-r pin-b h-3 w-3 "
                        :class="tr.inoutreference.status === 'IN' || tr.inoutreference.status === 'MIN'|| tr.inoutreference.status === 'BS'  ? 'bg-success' : 'bg-danger'"
                      ></div>
                      <!-- <div class="h-3 w-3 border-white border border-solid rounded-full absolute pin-r pin-b" v-else   :class="'bg-danger'"></div> -->
                    </div>
                    <div class="relative inline-flex float-left" v-else>
                      <vs-avatar
                        color="primary"
                        class="m-0 name-avatar"
                        :text="usernameList(tr.firstname,tr.lastname)"
                        size="40px"
                      />
                      <div class="user-inout absolute pin-r pin-b h-3 w-3" :class="'bg-danger'"></div>
                    </div>
                     <h6 class="pt-3 ml-16 break-words">{{ tr.firstname | capitalize}} {{tr.lastname | capitalize}}</h6>
                    <div
                      class="ml-16"
                    >{{ tr.inoutreference? manageStatus(tr.inoutreference.main_status,tr.inoutreference.status,tr.inoutreference.in_meeting,tr.inoutreference.is_on_leave):'Out' }}</div>
                  </vs-td>
                  <!-- <vs-td>{{ tr.firstname | capitalize}}</vs-td>
                  <vs-td>{{tr.lastname | capitalize}}</vs-td>-->

                  <vs-td width="500px">
                    <span v-if="tr.inoutreference">{{ tr.inoutreference.comment }}</span>
                  </vs-td>
                  <vs-td>
                    <span v-if="tr.inoutreference">
                      {{ !tr.inoutreference.is_on_leave?tr.inoutreference.due_back:dueBackFormate(tr.inoutreference.due_back,tr.inoutreference.due_back_leave_type) }}
                    </span>
                  </vs-td>
                  <vs-td>
                    <span v-if="tr.phone">{{ tr.phone }}</span>
                  </vs-td>
                  <vs-td class="pr-0">
                    <div
                      class="date-size"
                      v-if="tr.inoutreference"
                      v-html="checkDate(tr.inoutreference.start_time)"
                    >
                      <!-- {{ tr.inoutreference.start_time| moment('timezone',$store.state.uInfo.timeZone, 'MM-DD-YYYY h:mm a') }} -->

                      <!-- <span>By: </span> -->
                    </div>
                    <div v-else class>--</div>
                  </vs-td>
                  <vs-td class="pr-1 pl-1">
                    <vs-button
                      color="#F4B400"
                      type="flat"
                      class="mb-2 float-right"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      size="small"
                      @click.prevent="getSelectedUser(tr)"
                    ></vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div style="height:50px;">
            <div class="float-left">
              <vs-select label="Record Per Page" v-model="perPage" autocomplete>
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item,index) in recordList"
                />
              </vs-select>
            </div>
            <div class="float-right mt-5">
              <vs-pagination ref="paginationApplication" :total="totalPage" v-model="currentPage"></vs-pagination>
            </div>
          </div>
        </vx-card>
      </div>

      <!-- <div class="vx-col md:w-1/3 form-group w-full">
        <vx-card title="Manage Users">
          <h6>sadasdasdasdadsad</h6>
        </vx-card>
      </div>-->

      <div class="vx-col form-group right-sidebar-col">
        <!-- <vx-card :title="'Hi '+ username | capitalize" v-bind:class="'header-border'"  class="right-sidebar"> -->
        <vx-card class="right-sidebar">
          <!-- <div class="vx-card__header"> -->
          <div class="vx-card__title header-border w-full">
            <div class="w-full" v-if="!(username == selectedUsername)">
              <vs-button
                color="warning"
                type="border"
                class="mr-2 mb-2 float-right btn-close"
                icon-pack="feather"
                icon="icon-x"
                size="small"
                @click.stop="removeSelectedUser()"
              ></vs-button>
            </div>
            <h4 class="float-left mb-3">Hi {{(selectedUsername || username) | capitalize }}</h4>
          </div>
          <div class="w-full mb-3 float-left" v-if="clockInTime">
            <span class="font-bold">Clocked on:</span> {{ clockInTime }}
          </div>
          <!-- </div> -->
          
          <div class="top-action w-full float-left mt-1" :class="this.$store.state.liveStatus.main_status == 'CIN'?'btn-center':''">
            <vs-button
              class="btn-round mr-2 mb-2"
              radius
              color="#0F9D58"
              type="filled"
              title="In"
              icon-pack="feather"
              v-if="this.$store.state.liveStatus.status =='OUT' && this.$store.state.liveStatus.main_status == 'COUT'"
              icon="icon-check"
              @click.stop="changeStatus('IN')"
              :disabled="btnStatus"
            ></vs-button>
            <vs-button
              class="btn-round mr-2 mb-2"
              radius
              color="#DB4437"
              type="filled"
              title="Out"
              icon-pack="feather"
              v-if="this.$store.state.liveStatus.status =='OUT'  && this.$store.state.liveStatus.main_status == 'COUT'"
              icon="icon-x"
              @click.stop="changeStatus('OUT')"
              :disabled="btnStatus"
            ></vs-button>
            
            <vs-button
              class="btn-round mr-2 mb-2"
              radius
              color="#F4B400"
              type="filled"
              title="Lunch"
              icon-pack="feather"
              icon="icon-log-out"
              v-if="this.$store.state.liveStatus.status =='OUT'  && this.$store.state.liveStatus.main_status == 'COUT'"
              @click.stop="changeStatus('BI')"
              :disabled="btnStatus"
            ></vs-button>

            

            <vs-button
              class="btn-round mr-2 mb-2"
              radius
              color="#F4B400"
              type="filled"
              title="Meeting"
              icon-pack="feather"
              v-if="this.$store.state.liveStatus.status =='OUT'  && this.$store.state.liveStatus.main_status == 'COUT'"
              icon="icon-users"
              @click.stop="changeStatus('MIN')"
              :disabled="btnStatus"
            ></vs-button>
            <vs-button
              class="btn-round mb-2"
              radius
              color="#DB4437"
              type="filled"
              title="Clock Out"
              icon-pack="feather"
              icon="icon-home"
              v-if="this.$store.state.liveStatus.status =='OUT'  && this.$store.state.liveStatus.main_status == 'COUT'"
              @click.stop="changeStatus('COUT')"
              :disabled="btnStatus"
            ></vs-button>


            <div class="btn-wrapper yellow-btn mb-2" v-if="this.$store.state.liveStatus.main_status !=='COUT'"> 
              <vs-button  class="outline-custom-btn ">  
                  <div class="ml-2 mr-2">Break</div>              
              </vs-button>
              <div class="icon-wrapper">
                <div class="icon-custom-box">
                  <i class="feather icon-log-out" @click.stop="changeStatus('BI')"></i>
                </div>  
              </div>
            </div>

            <div class="btn-wrapper red-btn mb-2" v-if="this.$store.state.liveStatus.main_status !=='COUT'">
              <vs-button  class="outline-custom-btn ">  
                  <div class="ml-2 mr-2">Clock off</div>              
              </vs-button>
              <div class="icon-wrapper">
                <div class="icon-custom-box">
                  <i class="feather icon-log-out" @click.stop="changeStatus('COUT')"></i>
                </div>  
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <form class="w-full mt-5" autocomplete="off">
            <div class="vx-row mb-2">
              <div class="vx-col md:w-1/1 form-group w-full">
                <vs-input
                  class="w-full"
                  label="Comment"
                  placeholder="Comment"
                  name="comment"
                  v-model="comment"
                  autocomplete="off"
                />
                <!-- <span class="text-danger text-sm">{{ errors.first('comment') }}</span> -->
              </div>
              <div class="vx-col md:w-1/1 form-group w-full">
                <label class="vs-input--label">Due Back Time</label>
                <flat-pickr
                  class="vs-inputx vs-input--input normal time"
                  :config="configdateTimePicker"
                  v-model="dueBack"
                  placeholder="HH:MM"
                  name="due_back"
                />
                <vs-button
                  class="ml-3 time-clear home-refresh"
                  radius
                  type="filled"
                  title="In"
                  icon-pack="feather"
                  icon="icon-refresh-ccw"
                  @click="clearTime()"
                ></vs-button>
                <!--   <label class="vs-input--label">Due Back Time</label>
                <input
                  class="vs-inputx vs-input--input normal"
                  type="time"
                  name="due_back"
                  v-model="dueBack"
                  placeholder="HH:MM"
                />-->

                <!--<vue-clock-picker v-model="dueBack" value="12:09" placeholder="HH:MM"></vue-clock-picker>-->
                <!-- <span class="text-danger text-sm">{{ errors.first('department_name') }}</span> -->
              </div>
              <div class="vx-col md:w-1/1 form-group w-full">
                <ul class="flex">
                  <!-- <li>
                     <vs-radio  id="in-flag" name="flag" v-model="flag" :vs-value='true' >In</vs-radio>
                  </li>
                  <li>
                    <vs-radio class="mr-8" id="out-flag" name="flag" v-model="flag" :vs-value='false' >Out</vs-radio>
                  </li>-->
                  <li>
                    <vs-radio color="#34a853" class="mr-8" v-model="flag" vs-value="IN">IN</vs-radio>
                  </li>
                  <li>
                    <vs-radio color="#DB4437" v-model="flag" vs-value="OUT">OUT</vs-radio>
                  </li>
                </ul>
                <!-- <span class="text-danger text-sm">{{ errors.first('office_id') }}</span> -->
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-button
                  class="w-full md:w-1/1 m-auto ipad-font"
                  type="filled"
                  @click.prevent="updateInOutStatus()"
                  :disabled="btnStatus"
                >UPDATE STATUS</vs-button>
                <vs-button
                  class="w-full md:w-1/1 m-auto mt-2 ipad-font"
                  type="filled"
                  @click.prevent="bookVehicle()"
                >BOOK VEHICLE</vs-button>
              </div>
            </div>
            <!-- Quick picks -->

            <div class="vx-row mb-2 mx-1" v-if="quickPicks.length !== 0">
              <vs-list-item title="Quick Picks" class="mb-2 text-2xl w-full header-border"></vs-list-item>
              <div class="top-action w-full float-left mt-1">
            <vs-button
              class="btn-round mr-2 mb-2"
              radius
              color="#0F9D58"
              type="filled"
              title="In"
              icon-pack="feather"
              v-if="this.$store.state.liveStatus.main_status =='CIN'"
              icon="icon-check"
              @click.stop="changeStatus('IN')"
              :disabled="btnStatus"
            ></vs-button>
            <vs-button
              class="btn-round mr-2 mb-2"
              radius
              color="#DB4437"
              type="filled"
              title="Out"
              icon-pack="feather"
              v-if="this.$store.state.liveStatus.main_status =='CIN'"
              icon="icon-x"
              @click.stop="changeStatus('OUT')"
              :disabled="btnStatus"
            ></vs-button>
            <!-- <vs-button
              :class="this.$store.state.liveStatus.status == 'IN'?'btn-center btn-round mr-2 mb-2':'btn-round mr-2 mb-2'"
              radius
              color="#F4B400"
              type="filled"
              title="Lunch"
              icon-pack="feather"
              icon="icon-log-out"
              @click.stop="changeStatus('BI')"
              :disabled="btnStatus"
            ></vs-button> -->
            <vs-button
              class="btn-round mr-2 mb-2"
              radius
              color="#F4B400"
              type="filled"
              title="Meeting"
              icon-pack="feather"
              v-if="this.$store.state.liveStatus.main_status =='CIN'"
              icon="icon-users"
              @click.stop="changeStatus('MIN')"
              :disabled="btnStatus"
            ></vs-button>
            <!-- <vs-button
              class="btn-round mb-2"
              radius
              color="#DB4437"
              type="filled"
              title="Clock Out"
              icon-pack="feather"
              icon="icon-home"
              @click.stop="changeStatus('COUT')"
              :disabled="btnStatus"
            ></vs-button> -->
          </div>
              <draggable
                @change="changeOrder()"
                v-model="quickPicks"
                tag="ul"
                class="list-group list-group-flush cursor-move quick-list w-full"
              >
                <vs-list-item
                  icon-pack="feather"
                  class="w-full quickpick"
                  v-for="(quickPick, index) in quickPicks"
                  :title="quickPick.name"
                  @click.native="inOut(quickPick.status,quickPick.name)"
                  :key="index"
                >
                  <template slot="avatar">
                    <vs-avatar
                      icon
                      :color="quickPick.colour"
                      v-if="(quickPick.status=='IN' || quickPick.status == 'CIN')"
                    />
                    <vs-avatar icon :color="quickPick.colour" class="tea-brake" v-else />
                  </template>
                </vs-list-item>
              </draggable>
            </div>
          </form>
        </vx-card>
      </div>
    </div>
    <div v-if="$store.state.uInfo.role == 'SA'">
      <admin-dashboard></admin-dashboard>
    </div>
    <!-- Expired popup-->
    <div
      class="vs-component con-vs-dialog vs-dialog-danger custom-dialog"
      v-if="planExpire == true"
    >
      <div class="vs-dialog-dark"></div>
      <div class="vs-dialog">
        <header class="vs-dialog-header">
          <div class="con-title-after">
            <span class="after"></span>
            <h3
              class="dialog-title"
            >Hii {{$store.state.uInfo.firstname | capitalize}} {{$store.state.uInfo.lastname | capitalize}}</h3>
            <span>{{checkDate(tr.inoutreference.start_time)}}</span>
          </div>
        </header>
        <div class="vs-dialog-text">
          <p>Your Smart In Out trial period has expired</p>
          <br />
          <p>
            To proceed with your purchase please confirm you
            wish to go ahead with your SmartInOut subscription
          </p>
          <br />
          <div class="w-full text-center">
            <vs-button class color="success" type="relief" @click="expireConfirm()">I accept</vs-button>
          </div>
          <br />
          <p>If you no longer wish to use the SmartInOut board</p>
          <br />
          <div class="w-full text-center">
            <vs-button class color="danger" type="relief" @click="redirectTOLogout()">Decline</vs-button>
          </div>
        </div>
      </div>
    </div>

    <!-- confirm Popup-->
    <div
      class="vs-component con-vs-dialog vs-dialog-danger custom-dialog"
      v-if="confirmPopup == true"
    >
      <div class="vs-dialog-dark"></div>
      <div class="vs-dialog">
        <header class="vs-dialog-header">
          <div class="con-title-after">
            <span class="after"></span>
            <h3
              class="dialog-title"
            >Welcome {{$store.state.uInfo.firstname | capitalize}} {{$store.state.uInfo.lastname | capitalize}}</h3>
          </div>
        </header>
        <div class="vs-dialog-text float-left">
          <p>Thank you for choosing SmartInOut to be a part of your business process, we know your staff will love and look forward in serving your organisation in to the future.</p>
          <br />
          <p
            class="float-left mb-2"
          >Before we start please enter how many staff in your business will be using our system</p>
          <label class="float-left mt-2 mr-1">No Of Users :-</label>
          <vs-input
            type="number"
            @keydown="filterKey"
            class="w-1/4 float-left"
            v-validate="'required'"
            name="no_of_users"
            v-model="noOfUsers"
            autocomplete="off"
          />
          <br />
        </div>
        <footer>
          <vs-button
            class
            color="success"
            type="relief"
            :disabled="noOfUsers == null"
            @click="redirectTOSubscription()"
          >I accept</vs-button>
        </footer>
      </div>
    </div>

    <!-- <div class="vx-row mb-5">
      <div class="vx-col md:w-1/5" v-for="(quickPick, index) in quickPicks">
        <vx-card v-bind:class="'quickpick'">
          <div v-on:click="inOut(quickPick.status,quickPick.comment,quickPick.due_back)">
            <h4>
              <b>{{ quickPick.name }}</b>
            </h4>
            <p class="p-1">{{ quickPick.comment }}</p>
          </div>
        </vx-card>
      </div>
    </div>-->
  </div>
</template>

<script>
import draggable from "vuedraggable";
import moment from "moment";
// import fullscreen from 'vue-fullscreen';
import VueClockPicker from "@pencilpix/vue2-clock-picker";
import AdminDashboard from "../layouts/components/AdminDashboard";
// import '@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css';
import { EventBus } from "../mixins/mixin";

export default {
  components: {
    VueClockPicker,
    draggable,
    AdminDashboard
  },
  data() {
    return {
      list: [
        "Marzipan I love I love. Soufflé donut I love gummi bears powder. Candy danish biscuit.",
        "Halvah bonbon bonbon brownie sugar plum. Halvah I love cupcake I love.",
        "Cake muffin icing topping wafer topping gummi bears apple pie.",
        "Cotton candy gummi bears bear claw cake brownie jelly-o lemon drops croissant sweet roll."
      ],
      fullscreen: false,
      noOfUsers: null,
      planExpire: false,
      confirmPopup: false,
      mainStatus: null,
      office: null,
      department: null,
      allOffices: [],
      allDepartment: [],
      status: null,
      comment: null,
      dueBack: null,
      flag: "IN",
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        //dateFormat: "H:i",
        time_24hr: true
      },
      organisationUsers: [],
      quickPicks: [],
      totalPage: 1,
      currentPage: 1,
      recordList: [
        {
          text: 'All',
          value: -1
        },
        {
          text: 10,
          value: 10
        },
        {
          text: 25,
          value: 25
        },
        {
          text: 50,
          value: 50
        },
        {
          text: 100,
          value: 100
        },
        {
          text: 250,
          value: 250
        }
      ],
      search: null,
      selectedUser: null,
      in_meeting: false
    };
  },
  filters: {
    
  },
  watch: {
    status(nv) {
      if (nv.length === 0) {
        this.currentPage = 1;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
      }
      this.getusers();
    },
    currentPage(nv) {
      if (nv) {
        this.getusers();
      }
    },
    '$store.state.dashboardPagination'(val) {
      if(val){
        this.getusers();
      }
    },
    search(nv) {
      if (!nv) {
        this.currentPage = 1;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
        this.getusers();
      }
    }
  },
  computed: {
    perPage:{
			get() {
				return this.$store.state.dashboardPagination;
			},
			set(val) {
				this.$store.dispatch('updatePagination', val);
			}
		},
    username() {
      if (this.$store.state.uInfo) {
        return (
          this.$store.state.uInfo.firstname +
          " " +
          this.$store.state.uInfo.lastname
        );
      }
      return null;
    },
    clockInTime(){
      if (this.$store.state.uInfo.inoutreference && this.$store.state.uInfo.inoutreference.clock_in_time) {
        let timezone = this.$store.state.uInfo.timeZone;
        return moment.tz(this.$store.state.uInfo.inoutreference.clock_in_time, timezone).format('hh:mm A');
      }
      return null;
    },
    userCIN() {
      if (this.$store.state.uInfo) {
        return this.$store.state.uInfo.inOutStatus
          ? this.$store.state.uInfo.inOutStatus.clock_in_time
          : "-";
      } else {
        return this.selectedUser.inoutreference
          ? this.selectedUser.inoutreference.clock_in_time
          : "-";
      }
      return null;
    },
    selectedUsername() {
      if (this.selectedUser) {
        return this.selectedUser.firstname + " " + this.selectedUser.lastname;
      }
      return null;
    },
    selectedUserCIN() {
      if (this.selectedUser && this.selectedUser.inoutreference) {
        return this.selectedUser.inoutreference.clock_in_time;
      }
      return null;
    },
    btnStatus() {
      let status = false;
      if (this.$store.state.liveStatus) {
        if (this.$store.state.liveStatus.main_status !== "CIN") {
          status = true;
        }
      }

      return status;
    },
    colorGen() {
      var generateColor = Math.floor(Math.random() * 256);
      return "#99d6ff";
    }
  },
  mounted: function() {
    EventBus.$on("clockIn", () => {
      this.getusers();
    });
    if (
      this.$store.state.uInfo.role != "SA" &&
      this.$store.state.uInfo.payment_plan.is_freeplan == true &&
      this.$store.state.uInfo.is_plan_expire == true
    ) {
      this.planExpire = true;
    }
    // else{
    //    this.$router.push({ name: "organizationSettings" });
    // }

    if (this.$store.state.uInfo.role !== "SA") {
      this.liveInOutStatus();
      this.getDepartment();
        this.getusers();
      this.getOffice();
      this.getQuickPicks();
    }
      let that = this;
      setInterval(function() {
        if (that.$store.state.uInfo.role !== "SA") {
        that.getusersInterval();
        }
      }, 60 * 1000);
    setTimeout(() => {
      document.querySelector(".quickpick .con-vs-avatar").removeAttr("style");
    }, 1000);
  },
  methods: {
     manageStatus(main_status,status,inMeeting,isOnLeave){
      let text = '-';
      if(inMeeting){
        text = 'Unavailable';
      } else if(main_status == 'COUT' && isOnLeave){
        text = 'Leave';
      }
      else if (main_status == 'CIN' && status == 'IN') {
        text = 'In';
      }
      else if (main_status == 'COUT' && status == 'OUT') {
        text = 'Off';
      }
      else if (main_status == 'CIN' && status == 'BI') {
        text = 'Break';
      } 
      else if (main_status == 'CIN' && status == 'BS') {
        text = 'IN';
      }
      else if (main_status == 'CIN' && status == 'OUT') {
        text = 'Out';
      } else {
        text = 'Out';
      }
      return text;
    },
    changeOrder() {
      var new_order = [];
      this.quickPicks.forEach(function(value, i) {
        var obj = { quickPickId: value.id, order: i + 1 };
        new_order.push(obj);
      });
      let input = {
        id: this.$store.state.uInfo.organization,
        new_order: new_order
      };

      this.axios
        .put("quickPicks/editSortingOrder", input)
        .then(response => {
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
          this.$vs.loading.close();
        });
    },
    getSelectedUser(tr) {
      this.selectedUser = tr;
    },
    removeSelectedUser() {
      let obj = this.organisationUsers.find(
        ele => ele.id == this.$store.state.uInfo.id
      );
      this.selectedUser = obj;
    },
    redirectTOLogout() {
      this.logout();
      location.reload();
    },
    redirectTOSubscription() {
      this.$store.dispatch("updateNoOfUsers", this.noOfUsers);
      this.$router.push("/organization/settings?subcription=account");
    },
    toggle() {
      this.$fullscreen.toggle(this.$el.querySelector(".example"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    expireConfirm() {
      this.planExpire = false;
      this.confirmPopup = true;
    },
    checkDate(date) {
      let today = new Date();
      if ( moment(date).format("DD/MM/YYYY") == moment(this.today).format("DD/MM/YYYY")) {        
        return moment.tz(date, this.$store.state.uInfo.timeZone).format("hh:mm A") + " Today";
      } else {
        let tm = moment.tz(date, this.$store.state.uInfo.timeZone).format('hh:mm A');
        let dt = moment.tz(date, this.$store.state.uInfo.timeZone).format('MM-DD-YYYY');
        return tm + "</br>" + dt;
      }
    },
    usernameList(firstname, lastname) {
      let first = firstname.trim().charAt(0);
      let last = lastname.trim().charAt(0);
      let name = first.concat(last);
      return name.toUpperCase();
      /*  return firstname.trim() + " " + lastname.trim(); */
    },
    bookVehicle() {
      if (
        this.$store.state.uInfo.role === "CA" ||
        this.$store.state.uInfo.role === "HR"
      ) {
        this.$router.push("/organization/manage-vehicles?tab=book-vehicle");
        // this.$router.push({ name: "organizationManageVehicle" });
      }

      if (this.$store.state.uInfo.role === "U") {
        this.$router.push({ name: "userManageVehicle" });
      }
    },
    getQuickPicks() {
      let url = "quickPicks?from_admin=org";
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.quickPicks = data;
        })
        .catch(e => {
          this.showError(e);
        });
    },
    clearTime() {
      this.dueBack = null;
    },
    refreshTable() {
      this.search = null;
      this.department = null;
      this.office = null;
      this.getusers();
    },
    onChangeOffice() {
      this.getDepartment();
      this.getusers();
      this.department = null;
    },
    getOffice() {
      this.$vs.loading({ color: "primary" });

      let url = "office/getAll";
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.allOffices = data;
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    getDepartment() {
      this.$vs.loading({ color: "primary" });

      let url = "dept/getAll";
      if (this.office) {
        url += "?office_id=" + this.office;
      }
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.allDepartment = data;
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    getusersInterval(){
      let pageNo = this.currentPage - 1;
      let pageLimit = this.$store.state.dashboardPagination;

      let url = "user/getOrganizationalUser";
      if(pageLimit != -1){
        url += "?pageNo=" + pageNo + "&pageLimit=" + pageLimit;
      }
      if (this.search) {
        url += "&search=" + this.search;
      }
      if (this.office) {
        url += "&office=" + this.office;
      }
      if (this.department) {
        url += "&department=" + this.department;
      }

      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          let obj = data.find(ele => ele.id == this.$store.state.uInfo.id);
          this.selectedUser = obj;

          this.organisationUsers = data;
          this.totalPage = response.data.pages;
          })
        .catch(e => {
          this.showError(e);
        });
    },
    // ===== Get User List =====
    getusers() {
      this.$vs.loading({ color: "primary" });
      let pageNo = this.currentPage - 1;
      let pageLimit = this.$store.state.dashboardPagination;

      let url = "user/getOrganizationalUser";
      if(pageLimit != -1){
        url += "?pageNo=" + pageNo + "&pageLimit=" + pageLimit;
      }
      if (this.search) {
        url += "&search=" + this.search;
      }
      if (this.office) {
        url += "&office=" + this.office;
      }
      if (this.department) {
        url += "&department=" + this.department;
      }

      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          let obj = data.find(ele => ele.id == this.$store.state.uInfo.id);
          this.selectedUser = obj;

          this.organisationUsers = data;
          this.totalPage = response.data.pages;
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    exportCSV() {
      let pageNo = this.currentPage - 1;
      let pageLimit = this.$store.state.dashboardPagination;

      let url = "user/getOrganizationalUser?export=export";
      url += "&pageNo=" + pageNo + "&pageLimit=" + pageLimit;
      if (this.search) {
        url += "&search=" + this.search;
      }
      if (this.office) {
        url += "&office=" + this.office;
      }
      if (this.department) {
        url += "&department=" + this.department;
      }

      this.axios
        .get(url)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Users.csv");
          document.body.appendChild(link);
          link.click();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    updateInOutStatus() {
      this.inOut(this.flag, this.comment, this.dueBack, this.in_meeting);
      this.status = null;
      this.comment = null;
      this.dueBack = null;
      this.in_meeting = false;
      // setTimeout(() => {

      //   this.getusers();

      // }, 500);
      // location.reload();
    },
    changeStatus(status) {
      let comment = null;
      this.in_meeting = false;
      if (status === "BI") {
        this.mainStatus = "BI";
        comment = "Lunch Break";
      }
      if (status === "MIN") {
        // this.mainStatus = 'IN';
        status = "IN";
        comment = "In Meeting";
        this.in_meeting = true;
      }
      this.inOut(status, comment, this.dueBack, this.in_meeting);
      // setTimeout(() => {

      //   this.getusers();

      // }, 500);
    },
    inOut(status, comment, due_back, in_meeting) {
      this.$vs.loading({ color: "primary" });
      let user_id = this.selectedUser
        ? this.selectedUser.id
        : this.$store.state.uInfo.id;
      // if (this.$store.state.uInfo) {
      //   user_id = this.$store.state.uInfo.id;
      // }

      let input = {
        status: status,
        comment: comment,
        due_back: due_back,
        user_id: user_id,
        in_meeting: in_meeting
      };

      this.axios
        .post("inout/updateinoutStatus", input)
        .then(response => {
          this.clockIn = response.data.data.clock_in_time;
          this.liveInOutStatus();
          this.getusers();
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e, "#dep-addupdate");
          this.$vs.loading.close();
        });
    },
    dueBackFormate(time,type) {
      let tm = parseInt(time);
      if(type){
        if(type =='F'){
          if(time){
            return moment.tz(tm, this.$store.state.uInfo.timeZone).format('DD/MM/YYYY');
          } else {
            return "";
          }
        } else {
          if(time){
            return moment.tz(tm, this.$store.state.uInfo.timeZone).format('DD/MM/YYYY hh:mm A');
          } else {
            return "";
          }
        }
      } else{
        return "";
      }
    }
  },
  destroyed() {
    EventBus.$off('clockIn');
  },
};
</script>
<style>
.apexcharts-menu-icon {
  display: none;
}
.header-border .vx-card__header {
  padding-bottom: 10px !important;
  border-bottom: 1px solid rgb(10, 0, 0);
}
.btn-round {
  float: left !important;
}
.image-status {
  bottom: 65px;
  left: 42px;
  /* width: 2px !important;
    height: 2px !important; */
}
.list-name {
  display: inline-block;
  margin-top: 10px !important;
}
.time-clear {
  float: right !important;
  bottom: 38px;
  right: 1px;
  display: block;
  margin-bottom: -35px;
}
.time-clear.vs-button.vs-radius {
  border-radius: 6px !important;
}
.time .flatpickr-input {
  font-family: Arial;
}
.time-clear.vs-button {
  height: 37px !important;
  width: 34px !important;
}
.time-clear.vs-button .vs-icon {
  top: auto;
  font-size: 13px;
}
.quickpick:hover {
  background-color: #0057ff;
  color: white;
}
.quickpick {
  cursor: pointer;
}

.quickpick p {
  word-break: break-all;
}

.custom-dialog {
  z-index: 333333 !important;
}
.custom-dialog .vs-dialog {
  /* max-width: 650px !important; */
}

/* .icon
{
  margin-top: -30px;
} */

/* vue2-clock-picker.min.css */
/* .clock-picker__input {
  border: 1px solid gainsboro;
}
.clock-picker__input--error, .clock-picker__input--error.clock-picker__input--has-value {
  color: #F44336;
}
.clock-picker__input--error .clock-picker__input, .clock-picker__input--error.clock-picker__input--has-value .clock-picker__input {
    border-color: #F44336;
}
.clock-picker__input--has-value .clock-picker__input {
  border-color: #00E676;
}
.clock-picker__button {
  text-transform: uppercase;
  background: none;
  width: 24px;
  height: 24px;
  display: inline-block;
  border: 0;
  border-radius: 12px;
  line-height: 24px;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: #757575;
  font-weight: 500;
  font-size: 13px;
}
.clock-picker__button:hover {
    background-color: #f5f5f5;
}
.clock-picker__button:active {
    background-color: #ededed;
}
.clock-picker__button:focus {
    background-color: #e8e8e8;
}
.clock-picker__button--active, .clock-picker__button--active:active, .clock-picker__button--active:hover, .clock-picker__button--active:focus {
    background-color: #a48bd1;
    color: #fff;
}
.clock-picker__button[disabled] {
    opacity: .4 !important;
    cursor: default;
}
.clock-picker__button[disabled], .clock-picker__button[disabled]:active, .clock-picker__button[disabled]:hover, .clock-picker__button[disabled]:focus {
      background-color: #f5f5f5;
      color: #757575;
}

.clock-picker__dialog {
  display: none;
}
.clock-picker__dialog--active {
    display: block;
} */
/* .clock-picker__dialog-drop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 200;
} */
/* .clock-picker__dialog-body {
   position: fixed;
    top: 50%;
    left: 50%;
    max-width: 100%;
    max-height: 100%;
    overflow: auto;
    width: 320px;
    margin: -235px -160px;
    background-color: #fff;
    z-index: 201;
    transform: scale(1);
    border-radius: 5px;
    overflow: auto; */

/* top: 50%; */
/* left: 50%; */
/*   max-width: 100%;
    max-height: 100%; */
/* overflow: auto; */
/* width: 320px; */
/* margin: -235px -160px; */
/* background-color: #fff; */
/* z-index: 201; */
/* -webkit-transform: scale(1); */
/* transform: scale(1); */
/*     border-radius: 5px; */
/* overflow: auto;
}*/
/* .clock-picker__dialog-header {
    padding: 1.5rem 1.5rem;
    font-size: 2rem;
    text-align: center;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}
.clock-picker__dialog-header span:hover, .clock-picker__dialog-header span:focus {
      cursor: pointer;
}
.clock-picker__dialog-content {
    position: relative;
    width: 100%;
    height: 280px;
    margin-top: 24px;
    margin-bottom: 24px;
}
.clock-picker__dialog-content .clock-picker__hours,
    .clock-picker__dialog-content .clock-picker__minutes {
      position: absolute;
} */
/* .clock-picker__dialog-actions {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: row;
        flex-direction: row;
    border-top: 1px solid #f5f5f5;
    padding: .5rem;
} */
/* .clock-picker__dialog-action {
    padding: 0 1rem;
    margin: 0;
    background: transparent;
    border: 0;
    -ms-flex: 1;
        flex: 1;
    font-size: 16px;
    font-weight: 500;
    line-height: 32px;
    display: inline-block;
    cursor: pointer;
}
.clock-picker__dialog-action:hover {
      background-color: #f5f5f5;
}
.clock-picker__dialog-action:focus {
      background-color: #ededed;
}
.clock-picker__dialog-action:active {
      background-color: #e6e6e6;
}
.clock-picker__dialog-action[disabled] {
      background-color: #f5f5f5;
      color: #e6e6e6;
}
.clock-picker__dialog-action[disabled]:hover, .clock-picker__dialog-action[disabled]:focus, .clock-picker__dialog-action[disabled]:active {
        cursor: not-allowed;
}
.clock-picker__dialog .scale-enter-active,
  .clock-picker__dialog .scale-leave-active,
  .clock-picker__dialog .fade-enter-active,
  .clock-picker__dialog .fade-leave-active {
    transition: all .3s ease;
}
.clock-picker__dialog .scale-enter,
  .clock-picker__dialog .scale-leave-active {
    opacity: 0;
    transform: scale(0);
}
.clock-picker__dialog .fade-enter,
  .clock-picker__dialog .fade-leave-active {
    opacity: 0;
}

.clock-picker__hours {
  position: relative;
  width: 100%;
  height: 280px;
}

.clock-picker__minutes {
  position: relative;
  width: 100%;
  height: 280px;
}
 */
.btn-close .includeIconOnly.small .vs-icon {
  margin-top: 5px !important;
}
.vs-list--title {
  word-break: break-word;
}
.btn-center{
  display: flex !important;
  justify-content: center !important;
  flex-wrap: wrap;
  align-items: center;
}
</style>
<style lang="scss" scoped>
.btn-wrapper{
  position: relative;
  margin: 5px;
  width: fit-content;
  overflow: hidden;
  .icon-wrapper{
    position: absolute;
    content: "";
    left: 0px;
    top: 0;
  }
  .outline-custom-btn{
    padding: 0 !important;
    padding-left: 30px !important;
    width: fit-content !important;
    height: 32px !important;    
    background-color: transparent !important;
    border-left: 0;
    border-radius: 12px;
    
  }
  &.yellow-btn{
    .outline-custom-btn{    
        border: 1px solid #f4b400;
        color: #f4b400;
      } 
      .icon-custom-box{
      background-color: #f4b400;
      }
  }
  &.red-btn{
    .outline-custom-btn{    
        border: 1px solid #db4437;
       color: #db4437;
      } 
      .icon-custom-box{
        background-color: #db4437;
       }
    }
  .icon-custom-box{
    height: 32px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%; 
    i{
      font-size: 16px;
      color: #fff;
          
    }
  } 
}

</style>
